module.exports = __webpack_public_path__ + "static/payment-centered-9d6f1f3e12df4f8730f29d6101858359.png";